'use client'
import { landingpage_logo_drag } from '@/constants/trace'
import { trackEvent } from '@/lib/utils'
import Image from 'next/image'
import Link from 'next/link'
import { usePathname } from 'next/navigation'

const BOOKMARK_LINK_TITLE = '爱图表 – 不止生成，更可深度编辑的「图表智能体」'

export const Logo = ({ href, white }: { href?: string; white?: boolean }) => {
  const pathname = usePathname()

  // 仅在 landingpage（/）上报 logo 拖拽事件，避免污染 docs/blog 等页面指标。
  const handleLogoDrag = () => {
    if (pathname === '/') {
      trackEvent(landingpage_logo_drag)
    }
  }
  return (
    <div className="group relative z-20 mr-4 inline-flex items-center space-x-2 px-2 py-1 text-sm font-normal text-black">
      {/*
        这里保持浏览器原生链接拖拽语义：
        1) draggable=true 允许直接拖拽到书签栏
        2) 链接内保留真实文本节点，提升 Chromium 对书签名称的命中概率
        3) 不覆写 dragstart，避免自定义 dataTransfer 破坏原生命名逻辑
      */}
      <Link href="https://aitubiao.com" draggable aria-label={BOOKMARK_LINK_TITLE} className="relative flex items-center" onDragStart={handleLogoDrag}>
        {/*
          隐藏文本前置到图片之前，确保浏览器构造书签名称时优先命中这段链接文本。
        */}
        <span className="pointer-events-none absolute left-0 top-0 select-none whitespace-nowrap opacity-0">{BOOKMARK_LINK_TITLE}</span>

        <div className="relative h-[32px] w-[143px]">
          {href ? (
            <Image src={href} alt="" aria-hidden draggable={false} className="pointer-events-none" width={143} height={32} />
          ) : (
            <>
              <Image
                src={'https://cdn.aitubiao.com/static/images/itubiao/logo.png'}
                alt=""
                aria-hidden
                width={143}
                height={32}
                draggable={false}
                className={`pointer-events-none absolute left-0 top-0 transition-opacity duration-300 ease-in-out ${white ? 'opacity-0' : 'opacity-100'}`}
              />
              <Image
                src={'https://cdn.aitubiao.com/static/images/itubiao/logo-white.png'}
                alt=""
                aria-hidden
                width={143}
                height={32}
                draggable={false}
                className={`pointer-events-none absolute left-0 top-0 transition-opacity duration-300 ease-in-out ${white ? 'opacity-100' : 'opacity-0'}`}
              />
            </>
          )}
        </div>
      </Link>

      {/*
        收藏提示采用 hover 触发：
        - 视觉：紫底 + p-2 + 顶部三角箭头
        - 交互：仅 hover 可见，不拦截鼠标事件，避免影响 logo 点击/拖拽
      */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute left-2 top-full z-20 mt-2 w-max translate-y-1 whitespace-nowrap rounded-[4px] bg-[#685EF6] p-2 text-white opacity-0 transition-all duration-200 group-hover:translate-y-0 group-hover:opacity-100"
      >
        <div className="absolute left-12 top-0 h-2 w-2 -translate-y-1/2 rotate-45 bg-[#685EF6]"></div>
        <span className="text-[14px] leading-4">按 </span>
        <span className="text-[14px] font-semibold leading-4">Ctrl + D </span>
        <span className="text-[14px] leading-4">收藏本站或拖动</span>
        <span className="text-[14px] font-semibold leading-4"> LOGO</span>
        <span className="text-[14px] leading-4"> 到书签栏</span>
      </div>
    </div>
  )
}
